import { createContext, useContext } from 'react';

export type CountrySelectorContextValue = {
    open: boolean;
    openCountrySelector: () => void;
    closeCountrySelector: () => void;
    setOpen: (open: boolean) => void;
};

export const CountrySelectorContext = createContext<CountrySelectorContextValue | null>(null);

export function useCountrySelector(): CountrySelectorContextValue {
    const context = useContext(CountrySelectorContext);
    if (!context) {
        throw new Error('useCountrySelector must be used within CountrySelectorProvider');
    }
    return context;
}

/** Returns null outside CountrySelectorProvider. */
export function useOptionalCountrySelector(): CountrySelectorContextValue | null {
    return useContext(CountrySelectorContext);
}
